import { createSlice } from '@reduxjs/toolkit';
import { difference, union } from 'es-toolkit';

import { fetchBidLimitBalance } from './bidLimit.actions';
import { defaultBidLimitSlice } from './bidLimit.types';

const bidLimitSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchBidLimitBalance.pending, (slice, { meta }) => {
            slice.loading = union(slice.loading, [meta.arg.catalogId]);
        });
        builder.addCase(fetchBidLimitBalance.fulfilled, (slice, { meta, payload }) => {
            slice.loaded[meta.arg.catalogId] = Date.now();
            slice.loading = difference(slice.loading, [meta.arg.catalogId]);
            slice.byId[meta.arg.catalogId] = { balance: payload.bidLimitRemaining };
        });
        builder.addCase(fetchBidLimitBalance.rejected, (slice, { meta }) => {
            slice.loading = difference(slice.loading, [meta.arg.catalogId]);
        });
    },
    initialState: defaultBidLimitSlice,
    name: 'bidLimitNew',
    reducers: {},
});

export const { reducer: bidLimitReducer } = bidLimitSlice;
